/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Users_Permissions_User } from './Users_Permissions_User'
export type Matching = {
  id?: number
  score?: number
  type?: Matching.type
  identifier: string
  createdAt?: string
  updatedAt?: string
  createdBy?: Users_Permissions_User
  updatedBy?: Users_Permissions_User
}
export namespace Matching {
  export enum type {
    TAGS = 'tags',
    CULTURE = 'culture',
    PERSONALITY = 'personality',
    COGNITIVE = 'cognitive',
    MOTIVATIONS = 'motivations',
    TOTAL = 'total',
  }
}
